import Sticker from 'design-system/components/Sticker';

const ReadOnlyBooleanWidget = ({ id, value }: { id: string; value: boolean }) => (
  <Sticker key={id} variant={value ? 'green' : 'red'} aria-label={value ? 'true' : 'false'}>
    {value ? 'true' : 'false'}
  </Sticker>
);

export default ReadOnlyBooleanWidget;
